import { render, staticRenderFns } from "./VirtualDesktop.vue?vue&type=template&id=01ba1976"
import script from "./VirtualDesktop.vue?vue&type=script&lang=js"
export * from "./VirtualDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports